import { AcceptedFileExts, AcceptedMimeTypes } from '../../Shared/resources/DoxFileTypes'
import T from 'i18n-react';

/* Utility class used to deal with downloaded files */
class FileDownloadUtil {

    base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    getMimeType = (fileType) => {
        let idx = AcceptedFileExts.indexOf((fileType || '').toLowerCase())
        if (idx !== -1) {
            return AcceptedMimeTypes[idx]
        }
        return 'application/pdf'
    }

    downloadFile = (fileLink, fileName, openInTab) => {
        if (!openInTab) {
            // Trigger direct download
            const link = document.createElement('a');
            link.href = fileLink;
            link.download = fileName;

            // Append to DOM for compatibility
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // Clean up the DOM
        } else {
            // Open a blank new tab and write a wrapper page so the file displays
            // inline while the tab title and download link carry the correct filename.
            const downloadText = T.translate('ReviewAndApprove.AltPage2.Common.Download');
            const newTab = window.open('', '_blank');
            if (newTab) {
                const safeFileName = fileName
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
                newTab.document.write(
                    '<!DOCTYPE html><html><head><meta charset="utf-8">'
                    + '<title>' + safeFileName + '</title>'
                    + '<style>'
                    + '* { margin: 0; padding: 0; box-sizing: border-box; }'
                    + 'body { display: flex; flex-direction: column; height: 100vh; font-family: sans-serif; }'
                    + '.toolbar { display: flex; align-items: center; padding: 6px 12px; background: #f5f5f5; border-bottom: 1px solid #ddd; gap: 12px; }'
                    + '.toolbar span { font-size: 13px; color: #333; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }'
                    + '.toolbar a { font-size: 13px; text-decoration: none; color: #0078d4; white-space: nowrap; }'
                    + '.toolbar a:hover { text-decoration: underline; }'
                    + 'iframe { flex: 1; border: none; width: 100%; }'
                    + '</style></head><body>'
                    + '<div class="toolbar">'
                    + '<span>' + safeFileName + '</span>'
                    + `<a href="${fileLink}" download="${safeFileName}">${downloadText}</a>`
                    + '</div>'
                    + '<iframe src="' + fileLink + '#toolbar=0"></iframe>'
                    + '</body></html>'
                );
                newTab.document.close();
            }
        }

        // Clean up Blob URLs if applicable
        if (fileLink.startsWith("blob:")) {
            window.addEventListener('focus', () => URL.revokeObjectURL(fileLink), { once: true });
        }
    };
}

const fileDownloadUtil = new FileDownloadUtil();
export default fileDownloadUtil;
